import MobileViewport from '../appComponents/mobile/MobileViewport';
import MobileOverlayStyles from '../appComponents/mobile/MobileOverlayStyles';
import React, { Component } from 'react';
import PlatformLanguageButton from '../appComponents/mobile/PlatformLanguageButton';
import './css/RegisterFieldPolish.css';

import '../appComponents/mobile/css/MobileExperience.css';
import './css/RegisterMobileResponsive.css';
import '../appComponents/mobile/css/MobileDeviceWidth.css';
import '../appComponents/mobile/css/MobileResponsiveViewport.css';

import '../appComponents/mobile/css/MobileDeviceWidthGuard.css';
class RegisterMobileRender extends Component {
  render() {
    const { API, AWS, Amplify, Auth, Buffer, Button, ButtonContent, ButtonGroup, CampaignContract_latest, CampaignFactoryContract_latest, Component, Container, CryptoJS, Dropdown, DropdownMenu, Form, FormField, Fragment, Header, Icon, Image, Input, LENDERBLOCKADMINWHITELIST, Link, List, ListContent, ListDescription, ListHeader, ListIcon, ListItem, ListList, LoadingIcons, Modal, Mosaic, OrbitProgress, Radio, React, Storage, ThreeDot, Web3, applicantUsername, awsconfig, axios, axiosDoubleCallCounter, bip39, blenderCommissionPublicKey, blenderTransfersToPublicKey, checkValidAccountInterval, checkValidAuthTokenInterval, checkValidAuthTokenIntervalPeriod_ms, className, cognitoID, countryCodesJSON, createAccountTimer, currentUser, deploymentAddressLatest, ethers, isMobile, mimemessage, mode_light_dark, navigationHandler, primaryLanguage, region, register, routeProps, secretName, startCount, that, tokenLifeTimeLimit, touched, useParams, useRef, web3, weiBalance } = this.props;

    return (
(
          <div 
            className="pageBody tbp-mobile-register-page"
          >
<MobileViewport />
<MobileOverlayStyles />

              {/* Registration styles stay with this render file. */}
              <style>{`
/* Register mobile overlays only. Desktop and unrelated modals are untouched. */
.ui.page.dimmer.tbp-register-backdrop {
  display: flex !important;
  align-items: flex-start !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100dvh !important;
  max-height: 100dvh !important;
  padding: max(14px, env(safe-area-inset-top, 0px)) 8px max(14px, env(safe-area-inset-bottom, 0px)) !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  box-sizing: border-box !important;
  -webkit-overflow-scrolling: touch;
}
.ui.modal.tbp-register-overlay.tbp-mobile-dialog {
  --register-bg: #15263c;
  --register-text: #f2f7ff;
  --register-muted: #b3c5d9;
  --register-border: #33506d;
  --register-field: #1b334e;
  position: relative !important;
  top: auto !important;
  left: auto !important;
  inset: auto !important;
  display: block !important;
  flex: 0 1 auto !important;
  width: calc(100dvw - 16px) !important;
  max-width: 560px !important;
  min-width: 0 !important;
  height: auto !important;
  max-height: calc(100dvh - 28px) !important;
  margin: 0 auto !important;
  padding: 23px !important;
  border: 1px solid var(--register-border) !important;
  border-radius: 18px !important;
  background: var(--register-bg) !important;
  color: var(--register-text) !important;
  font-family: Lato, Arial, sans-serif !important;
  box-shadow: 0 20px 52px rgba(0, 0, 0, .35) !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  box-sizing: border-box !important;
  -webkit-overflow-scrolling: touch;
  text-align: left !important;
}
.ui.modal.tbp-register-overlay.tbp-mobile-dialog.light {
  --register-bg: #fff;
  --register-text: #19304a;
  --register-muted: #516b82;
  --register-border: #d3e1ed;
  --register-field: #f0f5f9;
  box-shadow: 0 20px 52px rgba(14, 35, 56, .2) !important;
}
.ui.modal.tbp-register-overlay.tbp-mobile-dialog.dark { background: var(--register-bg) !important; color: var(--register-text) !important; }
.ui.modal.tbp-register-overlay.tbp-mobile-dialog,
.ui.modal.tbp-register-overlay.tbp-mobile-dialog * { box-sizing: border-box !important; }
.ui.modal.tbp-register-overlay.tbp-mobile-dialog > .header,
.ui.modal.tbp-register-overlay.tbp-mobile-dialog > .content,
.ui.modal.tbp-register-overlay.tbp-mobile-dialog > .actions {
  position: static !important;
  display: block !important;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  height: auto !important;
  margin: 0 !important;
  padding: 0 !important;
  background: transparent !important;
  border: 0 !important;
  color: var(--register-text) !important;
  text-align: left !important;
}
.ui.modal.tbp-register-overlay.tbp-mobile-dialog > .header {
  padding: 0 0 17px !important;
  margin: 0 0 20px !important;
  border-bottom: 1px solid var(--register-border) !important;
  font: 750 clamp(21px, 5.4vw, 25px)/1.25 Lato, Arial, sans-serif !important;
  letter-spacing: -.02em;
  overflow-wrap: break-word;
}
.ui.modal.tbp-register-overlay.tbp-mobile-dialog h3 {
  margin: 0 0 20px !important;
  padding: 0 !important;
  font: 700 clamp(18px, 4.5vw, 21px)/1.35 Lato, Arial, sans-serif !important;
  color: var(--register-text) !important;
  text-align: left !important;
  overflow-wrap: anywhere;
}
.ui.modal.tbp-register-overlay.tbp-mobile-dialog p,
.ui.modal.tbp-register-overlay.tbp-mobile-dialog .tbp-register-message,
.ui.modal.tbp-register-overlay.tbp-mobile-dialog .tbp-register-loading {
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 0 18px !important;
  padding: 0 !important;
  color: var(--register-muted) !important;
  font: 500 16px/1.55 Lato, Arial, sans-serif !important;
  text-align: left !important;
  white-space: normal !important;
  overflow-wrap: anywhere;
}
.ui.modal.tbp-register-overlay.tbp-mobile-dialog .tbp-register-message { color: var(--register-text) !important; }
.ui.modal.tbp-register-overlay.tbp-mobile-dialog .tbp-register-modal-buttons {
  display: flex !important;
  flex-direction: column !important;
  gap: 12px !important;
  width: 100% !important;
  max-width: 100% !important;
  margin: 20px 0 0 !important;
  padding: 0 !important;
}
.ui.modal.tbp-register-overlay.tbp-mobile-dialog > .actions { margin-top: 22px !important; }
.ui.modal.tbp-register-overlay.tbp-mobile-dialog .ui.button {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  height: auto !important;
  min-height: 53px !important;
  margin: 0 !important;
  padding: 14px 17px !important;
  border: 1px solid #0fa991 !important;
  border-radius: 11px !important;
  background: #009e81 !important;
  color: #fff !important;
  font: 700 16px/1.35 Lato, Arial, sans-serif !important;
  text-align: left !important;
  white-space: normal !important;
  overflow-wrap: anywhere;
  cursor: pointer;
}
.ui.modal.tbp-register-overlay.tbp-mobile-dialog .ui.button.tbp-register-secondary {
  background: var(--register-field) !important;
  color: var(--register-text) !important;
  border-color: var(--register-border) !important;
}
.ui.modal.tbp-register-overlay.tbp-mobile-dialog .ui.button:disabled {
  opacity: .55 !important;
  cursor: not-allowed !important;
}
.ui.modal.tbp-register-overlay.tbp-mobile-dialog input#authCode {
  display: block !important;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  height: auto !important;
  min-height: 55px !important;
  margin: 0 !important;
  padding: 13px 16px !important;
  border: 1px solid var(--register-border) !important;
  border-radius: 11px !important;
  outline-offset: 2px;
  background: var(--register-field) !important;
  color: var(--register-text) !important;
  font: 700 21px/1.4 Lato, Arial, sans-serif !important;
  letter-spacing: .15em !important;
  text-align: left !important;
  box-shadow: none !important;
}
.ui.modal.tbp-register-overlay.tbp-mobile-dialog input#authCode::placeholder {
  color: var(--register-muted) !important;
  opacity: .7 !important;
}
.ui.modal.tbp-register-overlay.tbp-mobile-dialog input#authCode:focus-visible,
.ui.modal.tbp-register-overlay.tbp-mobile-dialog .ui.button:focus-visible {
  outline: 2px solid #28c9ae !important;
  outline-offset: 2px !important;
}
.ui.modal.tbp-register-overlay.tbp-mobile-dialog .tbp-register-error {
  color: #ffadae !important;
}
.ui.modal.tbp-register-overlay.tbp-mobile-dialog.light .tbp-register-error {
  color: #b62435 !important;
}
.ui.modal.tbp-register-overlay.tbp-mobile-dialog .tbp-register-loading {
  display: flex !important;
  flex-direction: row !important;
  justify-content: flex-start !important;
  align-items: center !important;
  gap: 16px !important;
  margin: 0 !important;
  padding: 8px 0 5px !important;
}
.ui.modal.tbp-register-overlay.tbp-mobile-dialog .tbp-register-loading > span:last-child {
  min-width: 0 !important;
  text-align: left !important;
}
.tbp-register-spinner {
  display: block;
  flex: 0 0 29px;
  width: 29px;
  height: 29px;
  border: 3px solid rgba(166, 197, 214, .35);
  border-top-color: #1cc3a4;
  border-radius: 50%;
  animation: tbp-register-spin .8s linear infinite;
}
.ui.modal.tbp-register-overlay.tbp-mobile-dialog.tbp-register-overlay--error { min-height: min(220px, calc(100dvh - 28px)) !important; }
.ui.modal.tbp-register-overlay.tbp-mobile-dialog.tbp-register-overlay--loading { min-height: min(180px, calc(100dvh - 28px)) !important; }
.ui.modal.tbp-register-overlay.tbp-mobile-dialog.tbp-register-overlay--terms { min-height: min(340px, calc(100dvh - 28px)) !important; }
@media (max-width: 359px), (max-height: 450px) {
  .ui.modal.tbp-register-overlay.tbp-mobile-dialog { padding: 17px !important; }
  .ui.modal.tbp-register-overlay.tbp-mobile-dialog > .header { margin-bottom: 16px !important; padding-bottom: 13px !important; }
}
@keyframes tbp-register-spin { to { transform: rotate(360deg); } }

              `}</style>





            <Modal centered={false} dimmer={{
  className: 'tbp-register-backdrop'
}} className={'tbp-register-overlay ' + (that.state.mode_light_dark == 'light' ? 'light' : 'dark') + ' tbp-mobile-dialog tbp-register-overlay--error'} open={Boolean(that.state.errorTags)} style={{
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}>
                <Modal.Header style={{
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>The Blender Platform</Modal.Header>
                <Modal.Content style={{
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}><div className="tbp-register-message" style={{}}>{that.state.errorTags}</div></Modal.Content>
                <Modal.Actions style={{}}><Button onClick={() => that.setState({
      errorTags: null
    })} style={{
      position: 'static',
      minHeight: 44,
      fontSize: 16,
      lineHeight: 1.4,
      boxSizing: 'border-box',
      margin: 0,
      padding: '12px 16px',
      maxWidth: '100%',
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
    }}>{that.state.selectedLanguage == 'spanish' ? 'Aceptar' : 'Okay'}</Button></Modal.Actions>
              </Modal>

            <Modal centered={false} dimmer={{
  className: 'tbp-register-backdrop'
}} className={'tbp-register-overlay ' + (that.state.mode_light_dark == 'light' ? 'light' : 'dark') + ' tbp-mobile-dialog tbp-register-overlay--loading'} open={Boolean(that.state.registrationLoading && !that.state.termsAndConfirmationCodeOverlay)} style={{
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}>
                <Modal.Header style={{
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>The Blender Platform</Modal.Header>
                <Modal.Content style={{
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}><div className="tbp-register-loading" role="status" aria-live="polite" style={{}}><span className="tbp-register-spinner" aria-hidden="true" style={{}} /><span style={{}}>{that.state.loadingText}</span></div></Modal.Content>
              </Modal>

            <Modal centered={false} dimmer={{
  className: 'tbp-register-backdrop'
}} className={'tbp-register-overlay ' + (that.state.mode_light_dark == 'light' ? 'light' : 'dark') + ' tbp-mobile-dialog tbp-register-overlay--terms'} open={that.state.termsAndConfirmationCodeOverlay} style={{
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}>
                <Modal.Header style={{
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>The Blender Platform</Modal.Header>
                <Modal.Content style={{
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}>
                  <h3 style={{}}>{that.state.termsAcceptedBool ? that.state.accountConfirmed ? that.state.selectedLanguage == 'spanish' ? 'Terminar la configuración' : 'Finish Account Setup' : that.state.selectedLanguage == 'spanish' ? 'Verifica tu correo electrónico' : 'Verify Your Email' : that.state.selectedLanguage == 'spanish' ? 'Términos de Uso y Política de Privacidad' : 'Terms of Use & Privacy Policy'}</h3>
                  {!that.state.termsAcceptedBool ? <div className="tbp-register-modal-buttons" style={{}}>
                      <Button className="tbp-register-secondary" disabled={that.state.registrationLoading} onClick={() => window.open('https://lenderblockcorp.com/termsandconditions-tbp', '_blank', 'noopener,noreferrer')} style={{
        position: 'static',
        minHeight: 44,
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        margin: 0,
        padding: '12px 16px',
        maxWidth: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
      }}>{that.state.selectedLanguage == 'spanish' ? 'Revisar los Términos de Uso' : 'Review Terms of Use'}</Button>
                      <Button className="tbp-register-secondary" disabled={that.state.registrationLoading} onClick={() => window.open('https://lenderblockcorp.com/privacypolicy-tbp', '_blank', 'noopener,noreferrer')} style={{
        position: 'static',
        minHeight: 44,
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        margin: 0,
        padding: '12px 16px',
        maxWidth: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
      }}>{that.state.selectedLanguage == 'spanish' ? 'Revisar la Política de Privacidad' : 'Review Privacy Policy'}</Button>
                      <Button disabled={that.state.registrationLoading} onClick={async () => {
        await that.showRegistrationLoading(that.state.selectedLanguage == 'spanish' ? 'Continuando…' : 'Continuing…');
        that.setState({
          termsAcceptedBool: true,
          registrationLoading: false,
          freezeButtonsBool: false
        });
      }} style={{
        position: 'static',
        minHeight: 44,
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        margin: 0,
        padding: '12px 16px',
        maxWidth: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
      }}>{that.state.selectedLanguage == 'spanish' ? 'Acepto los Términos de Uso y la Política de Privacidad' : 'I Accept the Terms of Use & Privacy Policy'}</Button>
                    </div> : <div style={{}}>
                      {!that.state.accountConfirmed && <div style={{}}>
                        <p style={{
          lineHeight: 1.5,
          overflowWrap: 'anywhere'
        }}>{that.state.selectedLanguage == 'spanish' ? 'Ingresa el código de 6 dígitos enviado a tu correo.' : 'Enter the 6-digit code sent to your email.'}</p>
                        <input name="one-time-code" id="authCode" type="text" inputMode="numeric" autoComplete="one-time-code" maxLength={6} aria-label={that.state.selectedLanguage == 'spanish' ? 'Código de verificación' : 'Verification Code'} placeholder="000000" value={that.state.authCode || ''} disabled={that.state.registrationLoading} onChange={event => that.setState({
          authCode: event.target.value.replace(/\D/g, '').slice(0, 6)
        })} style={{
          fontSize: 16,
          width: '100%',
          maxWidth: '100%',
          height: 'auto',
          minHeight: 48,
          padding: 12,
          margin: 0,
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: '1px solid rgba(128,128,128,.4)',
          borderRadius: 4,
          boxSizing: 'border-box'
        }} />
                      </div>}
                      {that.state.verificationError && <p className="tbp-register-error" role="alert" style={{
        lineHeight: 1.5,
        overflowWrap: 'anywhere'
      }}>{that.state.verificationError}</p>}
                      {that.state.verificationNotice && <p role="status" style={{
        lineHeight: 1.5,
        overflowWrap: 'anywhere'
      }}>{that.state.verificationNotice}</p>}
                      <div className="tbp-register-modal-buttons" style={{}}>
                        <Button disabled={that.state.registrationLoading || !that.state.accountConfirmed && !/^\d{6}$/.test(that.state.authCode || '')} onClick={() => that.confirmSignUp()} style={{
          position: 'static',
          minHeight: 44,
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
        }}>{that.state.accountConfirmed ? that.state.selectedLanguage == 'spanish' ? 'Continuar' : 'Continue' : that.state.selectedLanguage == 'spanish' ? 'Confirmar' : 'Confirm'}</Button>
                        {!that.state.accountConfirmed && <Button className="tbp-register-secondary" disabled={that.state.registrationLoading} onClick={() => that.resendConfirmationCode()} style={{
          position: 'static',
          minHeight: 44,
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
        }}>{that.state.selectedLanguage == 'spanish' ? 'Enviar otro código' : 'Resend Code'}</Button>}
                      </div>
                    </div>}
                  {that.state.registrationLoading && <div className="tbp-register-loading" role="status" aria-live="polite" style={{}}><span className="tbp-register-spinner" aria-hidden="true" style={{}} /><span style={{}}>{that.state.loadingText}</span></div>}
                </Modal.Content>
              </Modal>

            <div className="tbp-mobile-register-shell">


                <div className="tbp-mobile-register-top">
                    <img 
                        // className="logoImage" 
                        onClick={() => { 
                            that.setState({
                                forgottenPasswordBool: true,
                                navigationDestinationObject: {
                                    navigationRoute: '/welcome',
                                },
                              })
                        }}
                        src="https://lenderblockpublicicons.s3.amazonaws.com/TBPLogoSquare.png"
                    />
<div className="tbp-register-language-wrapper tbp-register-language-wrapper--mobile">
                    
                    <PlatformLanguageButton
                      selectedLanguage={that.state.selectedLanguage}
                      onToggle={() => {
                        const next = that.state.selectedLanguage === 'spanish' ? 'english' : 'spanish';
                        that.setState({ selectedLanguage: next });
                        try { localStorage.setItem('primaryLanguage', next); }
                        catch (error) { /* Browser storage may be unavailable. */ }
                      }}
                    />

                </div>
                </div>


                <div className="tbp-mobile-register-hero">

                    <div>


                        <p>
                            {that.state.selectedLanguage == 'spanish' ? 
                                'Bienvenido a Blender!  '
                                :
                                'Welcome to Blender!  '
                            }
                        </p>
                        <p>
                            {
                                !that.state.registrationCompleteA
                                ?
                                    that.state.selectedLanguage == 'spanish' ? 
                                    'Ingrese su nombre y apellido tal como aparecen en su identificación gubernamental.'
                                        :
                                    'Enter your first and last name as they appear on your government ID.'
                                :
                                    that.state.selectedLanguage == 'spanish' ? 
                                    'Contraseñas requieren 2 carácteres númerales, mayúsculas, minúsculas y especiales.'
                                    :
                                    'Passwords require 2 numeral, capital, lowercase, and special characters'
                            }
                        </p>
                    </div>

                </div>



                <div className="tbp-mobile-register-form-wrap">
                    <form autoComplete="on" onSubmit={event => { event.preventDefault(); if (that.state.registrationCompleteA) that.submitRegistration(); else that.goToCredentials(); }} className="tbp-register-body tbp-register-mobile-body">
                  {!that.state.registrationCompleteA ? (
                    <div>
                      
                      <input name="given-name"
                                    type="text" 
                                    id="firstName" 
                                    outline="none"
                                    autoComplete="given-name"
                                    onChange={(event) => {
                                        that.setState({
                                          firstName: event.target.value
                                        })
                                    }} 
                                    value={that.state.firstName || ''}
                                    maxLength={20}
                                    placeholder={
                                      that.state.selectedLanguage == 'spanish' ? 
                                        "Nombre"
                                          :
                                        "First Name"
                                    }
                                    style={{
                                        fontWeight: '600',
                                        fontFamily: 'arial',
                                        color: 'rgba(0, 0, 0, 1)',
                                        padding: 20,
                                        textAlign: 'left',
                                        textAlignVertical: 'center',
                                        height: '5vh',
                                        width: '84vw',
                                        borderRadius: '0.2vh',
                                        // marginTop: '1.75vh',
                                        fontSize: 17,
                                        borderStyle: 'none',
                                        border: 'none',
                                        borderBottomColor: 'rgba(177, 177, 177, 0)',
                                        backgroundColor: 'rgba(226, 226, 226, 1)',
                                        
                                    }}
                                />
<input name="family-name"
                                    type="text" 
                                    id="lastName" 
                                    outline="none"
                                    autoComplete="family-name"
                                    maxLength={20}
                                    onChange={(event) => {
                                        that.setState({
                                          lastName: event.target.value
                                        })
                                    }} 
                                    value={that.state.lastName || ''}
                                    placeholder={
                                      that.state.selectedLanguage == 'spanish' ? 
                                        "Apellido"
                                          :
                                        "Last Name"
                                    } 
                                    style={{
                                        fontWeight: '600',
                                        fontFamily: 'arial',
                                        color: 'rgba(0, 0, 0, 1)',
                                        padding: 20,
                                        textAlign: 'left',
                                        textAlignVertical: 'center',
                                        height: '5vh',
                                        width: '84vw',
                                        borderRadius: '0.2vh',
                                        marginTop: '1.75vh',
                                        fontSize: 17,
                                        borderStyle: 'none',
                                        border: 'none',
                                        borderBottomColor: 'rgba(177, 177, 177, 0)',
                                        backgroundColor: 'rgba(226, 226, 226, 1)',
                                        
                                    }}
                                />
                      <Dropdown
                                      className="tbp-register-country"
                                      search
                                      value={that.state.country || undefined}
                                      text={countryCodesJSON.find(option => option.value === that.state.country)?.text || undefined}
                                      aria-label={that.state.selectedLanguage === 'spanish' ? 'País' : 'Country'}
                                      noResultsMessage={that.state.selectedLanguage == 'spanish' ? 'No se encontraron países' : 'No countries found'}
                                    placeholder={that.state.selectedLanguage == 'spanish' ? 
                                        'País'
                                        :
                                        'Country'
                                    }
                                    
                                    fluid
                                    selection
                                    options={countryCodesJSON}
                                    onMouseDown={() => {
                                        that.setState({
                                        dropDownActiveBool: true,
                                        })
                                    }}
                                    onClose={() => {
                                        that.setState({
                                        dropDownActiveBool: false,
                                        })
                                    }}
                                    onChange={(event, data) => {
                                        const selectedCountry = countryCodesJSON.find(country => country.value === data.value);
                                        that.setState({
                                            dropDownActiveBool: false,
                                            country: data.value,
                                        })
                                        if(selectedCountry){
                                            if(selectedCountry.hasOwnProperty('key')){
                                                that.setState({
                                                countryCode: selectedCountry.key,
                                                })
                                            }
                                        }
                                    }}  
                                    style={{
                                        fontWeight: '600',
                                        fontFamily: 'arial',
                                        color: 'rgba(0, 0, 0, 1)',
                                        paddingBottom: '0.75vh',
                                        textAlign: 'left',
                                        textAlignVertical: 'center',
                                        // height: '5vh',

                                        // minHeight: auto !important,
                                        // height: '1em',
                                        maxHeight: '5vh',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        width: '84vw',
                                        fontSize: 17,
                                        borderStyle: 'none',
                                        // marginTop: '1.75vh',
                                        border: 'none',
                                        borderRadius: '0.2vh',
                                        borderBottomColor: 'rgba(177, 177, 177, 0)',
                                        backgroundColor: 'rgba(226, 226, 226, 1)',
                                        
                                    }}
                                  />
                      <div className="tbp-register-action"><Button    
                                    type="submit"
                                    disabled={
                                      String(that.state.firstName).length < 2 ||
                                      String(that.state.lastName).length < 2 ||
                                      String(that.state.country).length < 2
                                    }
                                    style={{
                                      height: '5vh',
                                      width: '84vw',
                                      borderRadius: '0.2vh',
                                      zIndex: 99999,
                                      borderWidth: 0,
                                      fontSize: 17,
                                      borderBottomColor: 'rgba(177, 177, 177, 0)',
                                      backgroundColor: 'rgba(226, 226, 226, 1)',
                                      alignItems: 'start',
                                      justifyContent: 'start',
                                      marginTop: '1.75vh',
                                      padding: 0,
                                      paddingLeft: '4vw', 
                                      paddingRight: 20,
                                      marginLeft: 0,
                                      marginRight: 0,
                                    }}
                                  >                
                                      <p style={{ fontSize: 17, textAlign: 'left', position: 'relative' , textAlignVertical: 'center', fontWeight: '600', color: 'rgba(0, 158, 129, 1)', }}> 
                                        {that.state.selectedLanguage == 'spanish' ? 
                                          'Entregar'
                                            :
                                          'Submit'
                                        }
                                      </p>
                                  </Button></div>
                    </div>
                  ) : (
                    <div>
                      
                      <input name="email"
                                      type="email"
                                      id="emailAddress"
                                      autoComplete="email"
                                      onChange={(event) => {
                                        that.setState({ emailAddress: event.target.value })
                                      }}
                                      value={that.state.emailAddress || ''}
                                      maxLength={254}
                                      placeholder={that.state.selectedLanguage == 'spanish' ? 'Dirección de Email' : 'Email Address'}
                                      aria-label={that.state.selectedLanguage == 'spanish' ? 'Dirección de Email' : 'Email Address'}
                                    />
                      <input name="username"
                                      type="text" 
                                      id="username" 
                                      outline="none"
                                      autoComplete="username"
                                      onChange={(event) => {
                                          that.setState({
                                            username: event.target.value
                                          })
                                      }} 
                                      value={that.state.username || ''}
                                      maxLength={15}
                                      placeholder={
                                        that.state.selectedLanguage == 'spanish' ? 
                                          "Usuario"
                                            :
                                          "Username"
                                      } 
                                      style={{
                                          fontWeight: '600',
                                          fontFamily: 'arial',
                                          color: 'rgba(0, 0, 0, 1)',
                                          padding: 20,
                                          textAlign: 'left',
                                          textAlignVertical: 'center',
                                          height: '5vh',
                                          width: '84vw',
                                          borderRadius: '0.2vh',
                                          fontSize: 17,
                                          borderStyle: 'none',
                                          border: 'none',
                                          borderBottomColor: 'rgba(177, 177, 177, 0)',
                                          backgroundColor: 'rgba(226, 226, 226, 1)',
                                          
                                      }}
                                  />
                      <input name="new-password"
                                      type="password" 
                                      id="password" 
                                      outline="none"
                                      autoComplete="new-password"
                                      onChange={(event) => {
                                          that.setState({
                                            password: event.target.value
                                          })
                                      }} 
                                      value={that.state.password || ''}
                                      maxLength={20}
                                      placeholder={
                                        that.state.selectedLanguage == 'spanish' ? 
                                          "Contraseña"
                                            :
                                          "Password"
                                      }  
                                      style={{
                                          fontWeight: '600',
                                          fontFamily: 'arial',
                                          color: 'rgba(0, 0, 0, 1)',
                                          padding: 20,
                                          textAlign: 'left',
                                          textAlignVertical: 'center',
                                          height: '5vh',
                                          width: '84vw',
                                          borderRadius: '0.2vh',
                                          fontSize: 17,
                                          borderStyle: 'none',
                                          border: 'none',
                                          borderBottomColor: 'rgba(177, 177, 177, 0)',
                                          backgroundColor: 'rgba(226, 226, 226, 1)',
                                          marginTop: '1.75vh',
                                          
                                      }}
                                  />
                      <input name="confirm-password"
                                      type="password" 
                                      id="passwordConf" 
                                      outline="none"
                                      autoComplete="new-password"
                                      onChange={(event) => {
                                          that.setState({
                                            passwordConfirm: event.target.value
                                          })
                                      }} 
                                      value={that.state.passwordConfirm || ''}
                                      maxLength={20}
                                      placeholder={
                                        that.state.selectedLanguage == 'spanish' ? 
                                          "Contraseña Confirmada"
                                            :
                                          "Confirm Password"
                                      }  
                                      style={{
                                          fontWeight: '600',
                                          fontFamily: 'arial',
                                          color: 'rgba(0, 0, 0, 1)',
                                          padding: 20,
                                          textAlign: 'left',
                                          textAlignVertical: 'center',
                                          height: '5vh',
                                          width: '84vw',
                                          borderRadius: '0.2vh',
                                          marginTop: '1.75vh',
                                          fontSize: 17,
                                          borderStyle: 'none',
                                          border: 'none',
                                          borderBottomColor: 'rgba(177, 177, 177, 0)',
                                          backgroundColor: 'rgba(226, 226, 226, 1)',
                                          
                                      }}
                                  />
                      <div className="tbp-register-action"><Button 
                                    type="submit"
                                    disabled={
                                      that.state.freezeButtonsBool ||
                                      !String(that.state.emailAddress).includes('@') ||
                                      !String(that.state.emailAddress).includes('.') ||
                                      String(that.state.username).length < 2 ||
                                      String(that.state.password).length < 2 ||
                                      String(that.state.passwordConfirm).length < 2 
                                    }
                                    style={{
                                      height: '5vh',
                                      width: '84vw',
                                      borderRadius: '0.2vh',
                                      zIndex: 99999,
                                      borderWidth: 0,
                                      fontSize: 17,
                                      borderBottomColor: 'rgba(177, 177, 177, 0)',
                                      backgroundColor: 'rgba(226, 226, 226, 1)',
                                      alignItems: 'start',
                                      justifyContent: 'start',
                                      marginTop: '1.75vh',
                                      padding: 0,
                                      paddingLeft: '4vw', 
                                      paddingRight: 20,
                                      marginLeft: 0,
                                      marginRight: 0,
                                    }}
                                  >                  
                                    <p style={{ fontSize: 17, textAlign: 'left', position: 'relative' , textAlignVertical: 'center', fontWeight: '600', color: 'rgba(0, 158, 129, 1)', }}> 
                                      {that.state.selectedLanguage == 'spanish' ? 
                                        'Confirmar'
                                          :
                                        'Confirm'
                                      }
                                    </p>
                                  </Button></div>
                    </div>
                  )}
                  <div className="tbp-register-login-return">
                    <Link to="/welcome" aria-label={that.state.selectedLanguage === 'spanish' ? 'Volver a iniciar sesión' : 'Back to Sign In'}>
                      <span aria-hidden="true">←</span>
                      {that.state.selectedLanguage === 'spanish' ? 'Volver a iniciar sesión' : 'Back to Sign In'}
                    </Link>
                  </div>
                </form>

                </div>

            </div>


          </div>
        )
    );
  }
}

export default RegisterMobileRender;
